import { CopyMetadataFromParent, Property, VeryLongString } from '@skylab-shared/core';
import { VatSummary } from '../document/vat-summary';
import { PurchaseDocumentKind } from './purchase-document-kind';
import { PurchaseInvoiceDocumentModel } from './purchase-invoice-document.model';

@CopyMetadataFromParent()
export class PurchaseInvoiceAdjustmentDocumentModel extends PurchaseInvoiceDocumentModel {
    @Property()
    @VeryLongString('data-model.purchase.validation.adjustment-reason.length')
    public adjustmentReason: string;

    @Property()
    public adjustedDocumentId: number;

    @Property()
    public adjustedDocumentVersion: string;

    @Property()
    public issueGoodsReceiptAdjustment: boolean;

    @Property()
    public override readonly kind: PurchaseDocumentKind = PurchaseDocumentKind.PurchaseInvoiceAdjustment;

    public vatSummary: VatSummary;
}
